import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TeamsService } from 'src/app/core/services/creatics/teams/teams.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;
  
  constructor(private service: TeamsService,private  dialog : MatDialog) { }

  data = [];
  heading:any
  description:any

  ngOnInit(): void {
    this.service.getTeamDetails().subscribe((res:any)=>{

      this.heading = res.heading
      this.description = res.description
      this.data = [...res.creaticsTeam];
      // console.log('team',this.data)

      this.data.sort((a, b) => {
     // Compare executive_level first
     const execLevelComparison = a.executive_level.localeCompare(b.executive_level);

     // If executive_level is the same, compare last names
     if (execLevelComparison === 0) {
       // Extract last names from full names
       const lastNameA = this.extractLastName(a.name);
        const lastNameB = this.extractLastName(b.name);

       
       return lastNameA.localeCompare(lastNameB);
     }

     return execLevelComparison;
   });
    })
  }

  private extractLastName(fullName: string): string {
    // Split the full name by spaces
    const nameParts = fullName.trim().split(' ');
    
    // Get the last part as the last name
    if (nameParts.length > 1) {
      return nameParts[nameParts.length - 1];
    }
    
    // If there's only one part, return it as the last name
    return nameParts[0];
  }
  openDialog(info:any){
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      data: {
        image: info.thumbnail,
        name: info.name,
        title: info.title,
        bio: info.bio
      }
    });
  }
}
